// @ts-expect-error TS(2306) File '/Users/dagobah/git/saas-nx/workspace/dist/libs/toktokdoc-lib/lib.js' is not a module.
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { UserRpps } from '@saas/interfaces/core'
import { capitalizeFirstLetter } from './stringUtils'

/**
 * @async
 * @description search required experts
 * @param {string} search string to search
 * @returns {Array<Object>} required expert list corresponding to the search string with id and libelle
 */
export const getSearchRequiredExperts = (hcsId: string) => async (search: any) => {
    try {
        const HCS = await ToktokdocLib.HealthCareService.findOne(hcsId)
        const result = await HCS.getPaginatedRequiredExperts(null, 10, search, null, {})

        const requiredExperts = result
            .filter((requiredExpert: any) => requiredExpert.status === 'active' && !requiredExpert.isRemoved)
            .map((requiredExpert: any) => ({
                libelle: `${requiredExpert.fullNameWithSpeciality}`,
                id: requiredExpert.id,
            }))

        return requiredExperts
    } catch (error) {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        console.log(`[searchRequiredExperts] error catched | message : ${error.message}`)
    }
    return false
}
export const formatPhysician = (physician: UserRpps) => {
    if (!physician || !physician.identifiantpp) return ''

    if (physician.codecivilitedexercice) {
        return `${physician.codecivilitedexercice}. ${physician.nomdexercice.toUpperCase()} ${capitalizeFirstLetter(
            physician.prenomdexercice,
        )} (${physician.identifiantpp})`
    }
    return `${physician.codecivilite}. ${physician.nomdexercice.toUpperCase()} ${capitalizeFirstLetter(
        physician.prenomdexercice,
    )} (${physician.identifiantpp})`
}
